export default {
  overFlowMenu: {
    tooltip: 'Ďalšie funkcie',
    export: 'Exportovať vlastné významy',
    import: 'Importovať vlastné významy',
  },
};
